/**
 * @generated SignedSource<<fba1d254b39eb8027a7a02d09be0864b>>
 * @relayHash d3272cca0e01df009404bb0b86b294b0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e1d0d5881b0df31a190d8e376f7e5c374ff8b5d53666f9755d90e6b95af4b28a

import type { ConcreteRequest, Query } from 'relay-runtime';
export type siteSwitcherLazyLoadQuery$variables = {
  hostNames: ReadonlyArray<string>;
};
export type siteSwitcherLazyLoadQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly cloudId: string | null | undefined;
    readonly hostName: string | null | undefined;
  } | null | undefined> | null | undefined;
};
export type siteSwitcherLazyLoadQuery = {
  response: siteSwitcherLazyLoadQuery$data;
  variables: siteSwitcherLazyLoadQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hostNames"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "hostNames",
        "variableName": "hostNames"
      }
    ],
    "concreteType": "TenantContext",
    "kind": "LinkedField",
    "name": "tenantContexts",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "hostName"
      },
      {
        "kind": "ScalarField",
        "name": "cloudId"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "siteSwitcherLazyLoadQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "siteSwitcherLazyLoadQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "e1d0d5881b0df31a190d8e376f7e5c374ff8b5d53666f9755d90e6b95af4b28a",
    "metadata": {},
    "name": "siteSwitcherLazyLoadQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9c3233e4eec42618cca922e320c99ef6";

export default node;
